import styled from "@emotion/styled"

import { motion } from "framer-motion"

const Svg = styled(motion.svg)`
  pointer-events: none;
`

const VB_WIDTH = 40
const VB_HEIGHT = 252

export default function WatermarkOyster({ className, ...props }) {
  return (
    <Svg viewBox={`0 0 ${VB_WIDTH} ${VB_HEIGHT}`} className={className ? `watermark ${className}` : "watermark"} {...props}>
      <title>Oyster</title>
      <defs>
        <linearGradient id='watermark-gradient'>
          <stop offset='5%' stopColor='white' stopOpacity={0.6} />
          <stop offset='95%' stopColor='white' stopOpacity={0.1} />
        </linearGradient>
      </defs>
      <g id='oyster' fill='url(#watermark-gradient)'>
        <path d='M.81,230.55c0,11.71,8.2,20.45,19.21,20.45s19.21-8.74,19.21-20.45-8.25-20.49-19.21-20.49S.81,218.84.81,230.55ZM33.05,230.55c0,8.08-5.28,13.48-13.03,13.48-7.79,0-13.03-5.4-13.03-13.48,0-8.08,5.24-13.52,13.03-13.52,7.75,0,13.03,5.44,13.03,13.52Z' />
        <path d='M38.57,191.26v-6.8s-15.71,0-15.71,0L1.47,166.86v8.58s15.17,12.41,15.17,12.41l-15.17,12.45v8.58s21.44-17.6,21.44-17.6h15.67Z' />
        <path d='M39.23,145.79c0-9.69-2.97-18.3-12-18.3-7.34,0-9.77,4.41-10.6,13.85l-.58,6.39c-.49,6.02-1.03,8.41-4.08,8.41-3.63,0-5.03-4.45-5.03-10.68,0-5.61.99-10.97,2.43-15.42l-6.39-1.07c-1.28,4.78-2.23,10.55-2.23,16.04,0,9.61,2.84,18.14,11.5,18.14,6.84,0,9.07-4.41,9.89-13.85l.54-6.39c.54-6.06,1.24-8.41,4.74-8.41,4.08,0,5.61,4.53,5.61,10.88,0,5.9-.99,11.5-2.43,16.24l6.39,1.07c1.28-4.99,2.23-11.13,2.23-16.9' />
        <path d='M38.57,108.19v-6.8s-30.96,0-30.96,0v-14.14s-6.14-.74-6.14-.74v36.61s6.14-.74,6.14-.74v-14.18h30.96Z' />
        <path d='M38.57,79.54l-.04-34.34-6.14.74v26.8h-9.89v-22.63s-6.18,0-6.18,0v22.63H7.65s-.04-26.01-.04-26.01l-6.14-.74v33.56s37.1,0,37.1,0Z' />
        <path d='M16.31,30.27H7.65V14.19c0-3.75,1.32-5.44,4.33-5.44,3.38,0,4.33,2.1,4.33,5.44v16.08ZM38.57,37.07v-6.8s-16.08,0-16.08,0v-11.87s16.08-9.65,16.08-9.65V1s-16.33,9.81-16.33,9.81c-.87-5.11-3.92-8.86-10.27-8.86S1.47,6.48,1.47,13.9v23.17s37.1,0,37.1,0Z' />
      </g>
    </Svg>
  )
}
